import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import YSDVT01 from './../workinstructions/images/YSDVT01.png';
import YSDVT70printdeliveries from './../workinstructions/images/YSDVT70printdeliveries.png';
import ysd_pack00 from './../workinstructions/images/ysd_pack00.png';
import YSD_PACK02 from './../workinstructions/images/YSD_PACK02.png';
import ysd_pack03 from './../workinstructions/images/ysd_pack03.png';
import ysd_pack04 from './../workinstructions/images/ysd_pack04.png';
import ysd_pack05 from './../workinstructions/images/ysd_pack05.png';
import OTMnr from './../workinstructions/images/OTM-nr.png';
import OTMscratch01 from './../workinstructions/images/OTMscratch01.png';
import OTMscratch02 from './../workinstructions/images/OTMscratch02.png';
import VT01Ncreateshipment01 from './../workinstructions/images/VT01N-createshipment01.png';
import LS2600 from './../workinstructions/images/LS26-00.png';
import LS2601 from './../workinstructions/images/LS26-01.png';
import LS2602 from './../workinstructions/images/LS26-02.png';
//import LT1200 from './../workinstructions/images/LT12-00.png';
//import LT1201 from './../workinstructions/images/LT12-01.png';

class OutboundGDC extends React.Component {
	async componentDidMount() {
    document.title = "Nokia MN Outbound";    
  }
	render() {
		return (
			<div>
		{/*				<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1>   */}
				<Panel>
					<PanelHeader>Nokia MN Outbound</PanelHeader>
					<PanelBody>
					<h2>Package</h2>
						<p>CTDI from Ratingen Germany and deliveries to Italy have to be shipped express !<br/>
						Deliveries to France have to be always on 120 cm length pallet, Euro-single pallet if the package is heavier than 21 kg
						</p>
						<p>Use YSD_PACK =&gt; fill in the delivery-number =&gt; Enter
							<p> <img src={ysd_pack00} alt="YSD_PACK 00" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							<p> <img src={YSD_PACK02} alt="YSD_PACK 02" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							Use YSD_Pack : paste delivery-nr  =&gt; enter =&gt; F8 =&gt; <br /> 
							<p> <img src={ysd_pack03} alt="YSD_PACK 03" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							go to PACK (shift F6) =&gt;  go to tab "single entry" =&gt; fill 1 in "HU Identification 2 " . This is the amount of the package you want to use for shipping =&gt; At HU Identification 2 
							=&gt; pack materials : fill in Nokia bpx barcode =&gt; enter <br />
							=&gt; scan barcode van item 2X =&gt; Go to Pack HUs : enter weight in Total Weight =&gt; save =&gt; Go back to first srceen =&gt; click on "Post-good-issue" or Pre-PGI.<br /><br />					
							<p> <img src={ysd_pack04} alt="YSD_PACK 04" style={{ maxWidth: '100%', height: 'auto' }} /> </p>				
							<p> <img src={ysd_pack05} alt="YSD_PACK 05" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							Use YSDVT70 to printout shipping and summery papers and address-label <br/>
							<p> <img src={YSDVT70printdeliveries} alt="YSDVT70 print deliveries" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							remove (shipmentnr en FI28) click on delivery =&gt; F8 =&gt; select all (F5) =&gt; Shift F2.<br />
							One version of shipping-paper will be keep as archive and give the account-team.<br /><br />
							Stick the export-label on the enveloppe containing Address-label =&gt;<br />
							Use OTM to fill in DHL and printout AWB
						</p>
						<h2>Create Shipment</h2>
						<p>
							Deliveries with the same address can be put in a shipment and there is permission for "CONSOLIDATION"<br />
							Start VT01N  =&gt; At "TransportPlanningPt " type in FI28<br />
							<p> <img src={VT01Ncreateshipment01} alt="VT01N create shipment for Nokia-MN" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							At select at shipment type = tracking Shipment =&gt; enter =&gt; F6 at type of deliveries =&gt; click op import from text file (Shift +F11) <br />
							=&gt; browse naar C-drive =&gt; users=&gt; user =&gt; desktop =&gt; select most recent RFID-files =&gt; F8 =&gt; F8 =&gt; pack (Shift + F9) =&gt; fill or scan the code of outerbox, packing material <br />
							=&gt; select all deliveries =&gt; select handling unit =&gt; click om pack =&gt; fill in weight =&gt; F3 =&gt; save <br />
							Start VT02N (change shipment) =&gt; enter =&gt; at Fwd Agen : 397003 =&gt; click on planning =&gt; click on shipment completion =&gt; save<br />
							For printing out shipment-papers =&gt; Start YSDVT70 =&gt; remove delivery & shipping point =&gt; click on “shipment”=&gt; F8 =&gt; F5 =&gt; shift +F2<br />
							Use OTM to create AWB<br />
							If you want to ship outside SAP, then crete OTM from scratch. select always economic; COURIER-IT<br />
						</p>
						<h2>OutBound common</h2>
						<p>
							Start YSD_PACK =&gt; fill in outbound-delivery-nr =&gt; go to pack =&gt; fill in 1 at HU2 identification =&gt; at HU fill in packing material of outerbox<br />
							Single entry Scan material & serial in =&gt; Go to "Pack" and fill in weight<br />
							save =&gt; pre-pgi <br />
							Start YSD_PACK =&gt; type in deliverynr =&gt; go to package =&gt; simple entry etc… =&gt; scan material & sn =&gt; PGI =&gt; <br/>
							use YSDVT70 for printout shipping-paper =&gt; remove shippingpoint.<br />
						</p>
						<h2>Packing delivery out of shipment</h2>
						<p>
							VT02N select on planning & shipment completion =&gt; go to pack=&gt; pack HUs =&gt; click on empty-icon to unpack =&gt; click on delete-icon to  delete package<br />
							=&gt; go to deliveries =&gt; delete transport =&gt; VL09
						</p>
						<h2>Sending IR-scrap to France DHL Gennevilliers</h2>
						<p>
							start YMB01 to receive goods with using of PO, create return delivery with VL01N, use YSD_PACK for packaging the delivery, Go to headernote 3 fill SCRAP =&gt; Hu2 type in 1 =&gt; scan in code of Outerbox =&gt; scan 2d-barocde in =&gt; enter =&gt; scan 2d-barocde in again =&gt; enter =&gt;
							Post Good Issue <br/>								
							Print out one paper of packinglist Start VL02N =&gt;  <br />
							Start VT01N =&gt; FI28<br />
							select at shipment type = tracking shipment , forward agent = 397003, select “planningand shipment completion” =&gt; click on deliveries =&gt; only outboundh deliveries =&gt;  scan delivery one by one<br />
							F8 =&gt; pack (Shift + F9) =&gt; fill in packing material =&gt; select all deliveries =&gt; select handling unit =&gt; click on pack =&gt; fill in the weight =&gt; F3 =&gt; save <br />
							In OTM from Scratch label making =&gt; sending the items to next address: DHL Services Logistiques, 99-101 Avenue Louis Roche, 92230 Gennevilliers, France.
							Sending with OTM-scratch and email to Customer Service shipment-number and AWB-number
						</p>
						<h2>Scratch order release in OTM</h2>																
						<p>
						At Source Location ID fill in FI26 for Tilburg =&gt; At Destination Location ID click on search-icon =&gt; select the right name and attention =&gt; click on "Finished"=&gt; at Source ERP SCRATCH =&gt;
						at DN Reference fill in IR-SCRAP Xvak =&gt; at ICO Term fill in "DAP"=&gt; then fill in info of pallet/colli. You have to fill in weight,height,length,width manually =&gt; Save =&gt;
						at DGR select "N"=&gt; click on "submit"=&gt; copy the OTM-number. That will be start with the date of today =&gt; Go to Manage Deliveries Finder and paste the OTM-nr in =&gt; 
						then process further as normal.=&gt;
	                    <p> <img src={OTMnr} alt="OTM Number" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
						<p> <img src={OTMscratch01} alt="OTM specific fields" style={{ maxWidth: '100%', height: 'auto' }} /> </p>					
	                    <p> <img src={OTMscratch02} alt="OTM scratch specific fields" style={{ maxWidth: '100%', height: 'auto' }} /> </p>					
							Destination-ID of DHL genevillier is 3370001817	=&gt; process further like normal otm					
	
						In "Courier Specific Fields "Go to DHL Shipping Account and fill in 191983782 =&gt; enter<br/>
						</p>
					</PanelBody>
						<footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
						  <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
						    &copy; Nov 2025 by TQT Tong. All rights reserved.
						  </p>
						</footer>
								
				</Panel>
		
			</div>
		)
	}
}

export default OutboundGDC;
